<template>
  <span 
    :class="[
      'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[12px] font-medium',
      statusClasses
    ]"
  >
    <span v-if="showIcon" class="mr-1">
      <svg v-if="status === 'active' || status === 'approved' || status === 'paid'" class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
      </svg>
      <svg v-else-if="status === 'pending' || status === 'payment_pending'" class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
      </svg>
      <svg v-else-if="status === 'archived' || status === 'closed'" class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
      <svg v-else-if="status === 'draft'" class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z" clip-rule="evenodd" />
      </svg>
    </span>
    {{ displayText }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  status: {
    type: String,
    required: true
  },
  showIcon: {
    type: Boolean,
    default: true
  },
  customText: {
    type: String,
    default: null
  }
})

const statusClasses = computed(() => {
  switch (props.status) {
    case 'active':
      return 'bg-sky-50 text-sky-700'
    case 'approved':
      return 'bg-emerald-50 text-emerald-700'
    case 'pending':
    case 'quote_requested':
      return 'bg-amber-50 text-amber-700'
    case 'payment_pending':
      return 'bg-amber-50 text-amber-700'
    case 'paid':
      return 'bg-emerald-50 text-emerald-700'
    case 'draft':
      return 'bg-gray-100 text-gray-700'
    case 'archived':
    case 'closed':
      return 'bg-gray-100 text-gray-600'
    case 'blocked':
    case 'declined':
      return 'bg-red-50 text-red-700'
    default:
      return 'bg-gray-100 text-gray-700'
  }
})

const displayText = computed(() => {
  if (props.customText) return props.customText
  
  switch (props.status) {
    case 'active':
      return 'Active'
    case 'approved':
      return 'Approved'
    case 'pending':
      return 'Pending'
    case 'quote_requested':
      return 'Pending Approval'
    case 'payment_pending':
      return 'Payment Pending'
    case 'paid':
      return 'Paid'
    case 'draft':
      return 'Draft'
    case 'closed':
      return 'Closed'
    case 'archived':
      return 'Archived'
    case 'blocked':
      return 'Blocked'
    default:
      return props.status.charAt(0).toUpperCase() + props.status.slice(1)
  }
})
</script>
